import { Delete, Get, Post, PostFormData, Put } from "../Request/Api";

export default {
  state: {
    AccountSettings: null,
    LicensingDetails:[],
    UserExams: [],
    courseTaught:[],
    coursesIDsAndTitle:[],
    userCEUs:[],
    toggleRemoteSessions: null,
    apiToken: localStorage.getItem("apiToken") || null,
  },
  getters: {
    GetToggleRemoteSessions(state: any) {
      return state.toggleRemoteSessions;
    },
    getUserCEUs(state: any) {
      return state.userCEUs;
    },
    getCourseTaught(state: any){
      return state.courseTaught;
    },
    GetCoursesIDsAndTitle(state) {
      return state.coursesIDsAndTitle;
    },
    GetAccountSettings(state: any) {
      return state.AccountSettings;
    },
    GetLicensingDetails(state: any) {
      return state.LicensingDetails;
    },
    getUserExams(state: any) {
      return state.UserExams;
    },
  },
  actions: {
    async GetUserAccountSettings({ commit }: any, payload: any) {
      return await Get(`User/GetUserAccountSettings?Id=${payload}`).then(
        (res: any) => {
          commit("SetAccountSettings", res.data.Data);

          return res.data;
        }
      );
    },
    async GetUserCEUs({ commit }: any, payload: any) {
      return await Get(`UserCEUs/GetUserCEUs?userId=${payload.id}&search=${payload.search}&StartDate=${payload.startDate}&EndDate=${payload.endDate}`).then((res: any) => {
        commit("SetUserCEUs", res.data.Data);
      });
    },
    async GetUserLicensingDetails({ commit }: any, payload: any) {
      return await Get(`User/GetInstructorLicensingDetails?InstructorId=${payload}`).then(
        (res: any) => {
          commit("SetInstructorLicensingDetails", res.data.Data);
          return res.data;
        }
      );
    },
    async ChangePassword({ commit }: any, payload: any) {
      return await Put(`User/ChangePassword`, payload).then(
        (res: any) => {
          return res.data;
        }
      );
    },
    async CancelMembership({ commit }: any, payload: any) {
      return await Put(`Membership/CancelUserMembership?userID=${payload}`, payload).then(
        (res: any) => {
          return res.data;
        }
      );
    },
    async DowngradeUserMembership({ commit }: any, payload: any) {
      return await Put(`Membership/DowngradeUserMembership?userID=${payload.id}&MemberShipID=${payload.membershipId}`, payload).then(
        (res: any) => {
          return res.data;
        }
      );
    },
    async UpdateAccountSetting({ commit }: any, payload: any) {
      return await Post(`User/UpdateAccountSetting`, payload).then(
        (res: any) => {
          return res.data;
        }
      );
    },
    async GetCourseTaught({ commit }: any, payload: any) {
      return await Get(`CourseTaught?id=${payload}`).then(
        (res:any) => {
          commit("SetCourseTaught", res.data.Data);
          return res.data.Data;
        }
      );
    },
    async GetCoursesIDsAndTitle({ commit }, payload) {
      return await Get(
        `Course/GetCoursesIDsAndTitle/1?pageSize=-1`
      ).then((res:any) => {
          commit("SetCoursesIDsAndTitle", res.data.Data.List);
        return res.data.Data;
      });
    },
    async ChangeUserEmail({ commit, state }: any, payload: any) {
      const headers = {
        // Authorization: `Bearer ${payload.token}`,
        Authorization: `Bearer ${state.apiToken || payload.token}`, 
      };
      return await Post(`User/ChangeUserEmail?userId=${payload.id}&email=${payload.email}`,{},headers ).then(
        (res: any) => {
          console.log("Full API Response:", res);
          if (res?.data?.Status) { // Ensure Status is checked correctly
            const newToken = res?.data?.Data?.Token; // Extract token directly
            console.log("Extracted Token:", newToken); // Verify token extraction
    
            if (newToken) {
              commit("SetApiToken", newToken); // Update Vuex state with new token
            }
          }
          return res.data;
        }
      );
    },
    async GetUserExams({ commit }: any, payload: any) {
      return await Get(`UserExams/GetUserExams?userId=${payload.id}`).then(
        (res:any) => {
          commit("SetUserExams", res.data.Data);
        }
      );
    },
    async ToggleRemoteSessions({ commit }: any, payload: any) {
      return await Get(`User/ToggleRemoteSessions?userId=${payload.id}`).then(
        (res:any) => {
          commit("SetToggleRemoteSessions", res.data.Data);
        }
      );
    },
  },
  mutations: {
    SetApiToken(state: any, payload: string) {
      console.log("New Token Committed:", payload); // Ensure this logs the token
      state.apiToken = payload;
      localStorage.setItem("apiToken", payload); // Persist token
    },
    SetToggleRemoteSessions(state: any, payload: any) {
      state.toggleRemoteSessions = payload;
    },
    SetUserCEUs(state: any, payload: any) {
      state.userCEUs = payload;
    },
    SetCourseTaught(state: any, payload: any) {
      state.courseTaught = payload;
    },
    SetCoursesIDsAndTitle(state, payload) {
      let coursesActiveList = payload
        .sort((a, b) => a.Title.localeCompare(b.Title));
      state.coursesIDsAndTitle = coursesActiveList;
    },
    SetAccountSettings(state: any, payload: any) {
      if (payload && payload.ProfileImage) {
        payload.ProfileImage = process.env.VUE_APP_IMG_URL + payload.ProfileImage;
      }
      state.AccountSettings = payload;
    },
    SetInstructorLicensingDetails(state: any, payload: any) {
      state.LicensingDetails = payload;
    },
    
    SetUserExams(state: any, payload: any) {
      state.UserExams = payload;
    },
  },
};
